/** Split API subscription fields into card heading / bullets / description. */

export const getSubscriptionDisplayCopy = (subscription) => {
  const features = subscription?.features || [];
  const headingFromFeatures = features.find((feature) =>
    /^includes everything in /i.test(String(feature))
  );

  return {
    features: headingFromFeatures
      ? features.filter((feature) => feature !== headingFromFeatures)
      : features,
    description: subscription?.description || "",
    includesFrom:
      subscription?.includesFrom ||
      headingFromFeatures ||
      "What's Included:",
    popular: Boolean(subscription?.popular),
  };
};
